export const Routes = {
  ABOUT: "/#about",
  GALLERY: "/#gallery",
  OPENING_HOURS: "/#openingHours",
  CONTACTS: "/#contacts",
  PROVIDERS: "/providers",
  // The link a provider shares (an Instagram bio, say): their calendar, chosen already.
  PROVIDER_LINK: "/providers/:providerId",
  SUPPLY: "/supply",
  BOOKING: "/booking",
  LOGIN: "/login",
  REGISTER: "/register",
  VERIFY_EMAIL: "/verify-email",
  FORGOT_PASSWORD: "/forgot-password",
  COMPLETE_REGISTRATION: "/complete-registration",
  SUCCESSFUL_AUTH: "/successful-auth",
  CONFIRM_BOOKING: "/confirm-booking",
  PENDING_APPROVAL: "/pending-approval",
  BOOKING_SUCCESS: "/booking-success",
  PROFILE: "/profile",
  EMAIL_ACTION: "/email-action/:type/:bookingId",
  EMAIL_ACTION_SUCCESS: "/email-action/:type",
  PRIVAY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  ERROR: "/error",
  DASHBOARD: "/dashboard",
  DASHBOARD_BLOCK_PERIOD: "/dashboard/block-period",
  DASHBOARD_OPENING_HOURS: "/dashboard/opening-hours",
  DASHBOARD_GUESTS: "/dashboard/guests",
  DASHBOARD_COUPONS: "/dashboard/coupons"
};